import { render, staticRenderFns } from "./platform_brands.vue?vue&type=template&id=9ed39c60&scoped=true&"
import script from "./platform_brands.vue?vue&type=script&lang=js&"
export * from "./platform_brands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed39c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ed39c60')) {
      api.createRecord('9ed39c60', component.options)
    } else {
      api.reload('9ed39c60', component.options)
    }
    module.hot.accept("./platform_brands.vue?vue&type=template&id=9ed39c60&scoped=true&", function () {
      api.rerender('9ed39c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/platform_brands.vue"
export default component.exports